import { render, staticRenderFns } from "./EmailNotificationsView.vue?vue&type=template&id=0145d77d&"
import script from "./EmailNotificationsView.vue?vue&type=script&lang=ts&"
export * from "./EmailNotificationsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports